import { accountingSystemConfig } from '../constants/accountingSystems';
/**
 *
 * @param {Organisation} org
 * @param term: string
 * @returns looks up an accounting system specific setting
 * if there is one for the given org's accounting system returns it.
 * If nothing is found it returns false.
 */
export function accountingSystemSpecificSetting(org, setting) {
    var _a;
    // TODO, fix when using org model everywhere
    const type = (org === null || org === void 0 ? void 0 : org.accounting_connection_type) || (org === null || org === void 0 ? void 0 : org.type);
    return ((_a = accountingSystemConfig[type]) === null || _a === void 0 ? void 0 : _a.settings[setting]) || false;
}
/**
   *
   * @param {Organisation} org
   * @param term: string
   * @returns looks up an accounting system specific term for the requested term
   * if there is one for the given org's accounting system.
   * If nothing is found it just returns the original term.
   */
export function accountingSystemSpecificTerm(org, term) {
    var _a, _b;
    // TODO, fix when using org model everywhere
    const type = (org === null || org === void 0 ? void 0 : org.accounting_connection_type) || (org === null || org === void 0 ? void 0 : org.type);
    return ((_b = (_a = accountingSystemConfig === null || accountingSystemConfig === void 0 ? void 0 : accountingSystemConfig[type]) === null || _a === void 0 ? void 0 : _a.terminology) === null || _b === void 0 ? void 0 : _b[term]) || term;
}
export function accountingSystemTooltip(org, policyField) {
    var _a, _b;
    // TODO, fix when using org model everywhere
    const type = (org === null || org === void 0 ? void 0 : org.accounting_connection_type) || (org === null || org === void 0 ? void 0 : org.type);
    return (_b = (_a = accountingSystemConfig[type]) === null || _a === void 0 ? void 0 : _a.tooltips) === null || _b === void 0 ? void 0 : _b[policyField];
}
//# sourceMappingURL=accountingSystemUtils.js.map